module.exports = __webpack_public_path__ + "static/media/train_62.4fb9a0a7.jpg";